/**
 * Shared responsive component for displaying program levels in expanded rows
 * Automatically adapts between mobile card layout and desktop TableDetailsPanel
 */

import { Row } from "@tanstack/react-table";
import TableDetailsPanel from "@/components/TableDetailsPanel";
import { getStatusTagColor } from "../../[universityId]/_utils";
import { buildProgramLevelColumns } from "../_utils";
import { ProgramLevel } from "../types";

interface Props {
  row: Row<any>;
  programLevels?: ProgramLevel[];
}

/**
 * Displays program levels in an expandable row
 * Shows only the program levels returned from the query
 *
 * @param row - Table row data
 * @param programLevels - Optional program levels array (defaults to row.original.programLevels)
 */
export const ExpandedProgramLevelsRow = ({ row, programLevels }: Props) => {
  const levels = programLevels || row.original.programLevels || [];

  const programLevelColumns = buildProgramLevelColumns(getStatusTagColor);

  return <TableDetailsPanel data={levels} columns={programLevelColumns} title={`Program Levels (${levels.length})`} />;
};
